var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var SchoolSearch = require("components/org/roster/SchoolSearch");
var LoadingButton = require("components/utility/LoadingButton");
var CleverLinkDistrictOrg = require("components/appdev/wizards/CleverLinkDistrictOrg");
var CleverLinkSchoolOrgs = require("components/appdev/wizards/CleverLinkSchoolOrgs");
var CleverLinkDistrictAdmins = require("components/appdev/wizards/CleverLinkDistrictAdmins");
var CleverLinkSections = require("components/appdev/wizards/CleverLinkSections");
var CleverProvisioningForm = require("components/appdev/wizards/CleverProvisioningForm");
var CleverSyncDistrictData = require("components/appdev/wizards/CleverSyncDistrictData");
var MergeUsersForm = require("components/users/shared/MergeUsersForm")
var CleverListEvents = require("components/appdev/wizards/CleverListEvents")

var DisplayToggleControl = require("components/utility/DisplayToggleControl");

import { Link } from "react-router-dom";

require("appdev/wizards/clever_access_token_details_page.scss");

class CleverAccessTokenDetailsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { accessToken: null, 
			selectedCanonicalIDs: {}, 
			loading: false, 
			sections: {}, 
			sectionLoading: false,
			currentStep: "1-link-district" };
	}

	displayDistrictOrgName() {
		if (this.state.accessToken.district_org) {
			var districtOrg = this.state.accessToken.district_org
			var route = "/district_orgs/" + districtOrg.id + "/details/controls";
			return (
				<Link to={ route }>
					Linked District Org: { districtOrg.name } ({ districtOrg.state }) | canonical id: { districtOrg.canonical_id }
				</Link>
			);
		}
	}
	
	renderCleverSchool(school_id) {
		const school = _.values(_.pick(this.state.schools, (school) => school.clever_id == school_id))[0]
		var rows = _.map(this.state.sections[school.clever_id], (section, i) => {

			return (
				<tr key={i}>
					<td>
						{ section.name }
					</td>
					<td>
						{ section.grade }
					</td>
					<td>
						{ section.subject }
					</td>
					<td>
						{ section.teachers.length }
					</td>
					<td>
						{ section.student_count }
					</td>
					<td>
						{ section.student_lists_id ? "yes" : "no" }
					</td>
					<td>
						<input type="radio" checked={section.selected} onClick={this.toggleSectionSelect.bind(this, section)}></input>
					</td>
					
				</tr>
			)
		})
		if (this.state.sectionLoading) {
			var loader = <Spinner placeholder={ true } scale={ 1.7 } />
		}
		return (
			<div>
				<Link to={ this.getBaseUrl() }>
					{ school.name } { loader}
				</Link>
				<table className="table">
					<thead>
						<tr>
							<th>
								Name
							</th>
							<th>
								Grade
							</th>
							<th>
								Subject
							</th>
							<th>
								Teachers
							</th>
							<th>
								Students
							</th>
							<th>
								Provisioned
							</th>
							<th>
								Selected
							</th>
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
			</div>
		)

	}

	getBaseUrl() {
		return "/clever_access_tokens/" + this.state.accessToken.id + "/details"
	}

	getSchoolLink(school) {
		var route = this.getBaseUrl() + "?school_id=" + school.clever_id;
		return (
			<Link to={ route } onClick={this.loadSections.bind(this, school)}>
				{ school.name }
			</Link>
		);
	}

	renderCleverSchools() {
		const schools = this.state.schools
		var rows = _.map(schools, (school, i) => {
			var link = this.getSchoolLink(school)
			return (
				<tr key={i}>
					<td>
						{ link }
					</td>
					<td>
						{ school.section_count }
					</td>
					<td>
						{ school.school_org_id ? "yes" : "no" }
					</td>
					
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							Name
						</th>
						<th>
							Sections
						</th>
						<th>
							Provisioned
						</th>
					</tr>
				</thead>
				<tbody>
					{ rows }
				</tbody>
			</table>
		)
	}

	renderCleverDistrict() {
		const district = this.state.accessToken.district
		var school_id = $wr.getURLParameterByName("school_id");
		if (school_id) {
			var view = this.renderCleverSchool(school_id)
		} else if (district.schools) {
			var view = this.renderCleverSchools()	
		}
		 
		return (
			<div>
				{ view }
			</div>
		)
	}

	renderCleverDistrictAdmins() {
		var rows = _.map(this.state.admins, (admin, i) => {
			
			return (
				<tr key={i}>
					<td>
						{ [admin.first_name, admin.last_name].join(" ") }
					</td>
					<td>
						{ admin.role }
					</td>
					<td>
						{ admin.title }
					</td>
					<td>
						{ admin.email }
					</td>
					<td>
						<input type="radio" checked={admin.selected} onClick={this.toggleAdminelect.bind(this, admin)}></input>
					</td>
					
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							Name
						</th>
						<th>
							role
						</th>
						<th>
							title
						</th>
						<th>
							email
						</th>
						<th>
							selected
						</th>
					</tr>
				</thead>
				<tbody>
					{ rows }
				</tbody>
			</table>
		)
	}

	renderSyncedAt() {
		const accessToken = this.state.accessToken
		if (!accessToken && accessToken.clever_district) {
			return ""
		}
		
		if (accessToken && accessToken.synced_at) {
			return (
				<div>
					District synced: { accessToken.synced_at }
				</div>
			)
		}
	}

	///////////////////// 2 - PROVISIONING STEP
	/////////// 2A - SCHOOLS

	getSchoolsToProvision() {
		const schools = this.state.schools
		return _.values(_.pick(schools, (school) => {
			return !school.school_org_id && _.keys(_.pick(school.sections, (section) => section.selected)).length > 0
		}))
	}

	shouldProvisionSchools() {
		return this.getSchoolsToProvision().length > 0
	}

	selectSchool(school, selected ) {
		console.log(selected, school)
		var selectedCanonicalIDs = this.state.selectedCanonicalIDs
		selectedCanonicalIDs[school.clever_id] = selected.value
		this.setState({ selectedCanonicalIDs })
	}
	renderSchoolSearch(school) {
		return (
			<div>
				<SchoolSearch ref="search" onSelect={ this.selectSchool.bind(this, school) }
					selectedSchool={ this.state.selectedSchool } />
			</div>
		);
	}
	renderProvisionSchools() {
		var schools_with_selected = this.getSchoolsToProvision()

		var rows = _.map(schools_with_selected, (school, s) => {
			// GRAB STATE AND ZIP FROM CLEVER OBJECT
			var canonicalZip = null
			var canonicalState = null
			if (school.data.location) {
					if (school.data.location.zip) {
						canonicalZip = school.data.location.zip	
					}
					if (school.data.location.state) {
						canonicalState = school.data.location.state
					}
			} else {
				canonicalState = <input className="form-control" type="text" ref={school.clever_id + "-state"}/>
			}

			if (school.clever_id in this.state.selectedCanonicalIDs) {
				var canonicalSchool = this.state.selectedCanonicalIDs[school.clever_id]
				var canonicalId = <input className="form-control" type="text" ref={school.clever_id + "-cid"} defaultValue={canonicalSchool.id} />
				// GRAB ZIP FROM CANONICAL IF MISSING FROM CLEVER
				if (!canonicalZip) {
					canonicalZip = <input className="form-control" type="text" ref={school.clever_id + "-zip"} defaultValue={canonicalSchool.zip} />	
				}
			} else {
				var canonicalId = this.renderSchoolSearch(school)
			}
			return (
				<tr key={s}>
					<td>
						{ school.name }
					</td>
					<td>
						{ canonicalZip }
					</td>
					<td>
						{ canonicalState }
					</td>
					<td>
						{ canonicalId }
					</td>
				</tr>
			)
		})
		return (
			<div>
				<table className="table">
					<thead>
						<th>
							School Name
						</th>
						<th>
							Zip
						</th>
						<th>
							State
						</th>
						<th>
							Canonical ID
						</th>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
				<LoadingButton loading={ this.state.loading }
					text={ "Provision Schools" }
					className={ "btn btn-primary" }
					onClick={ this.provisionSchools } />
			</div>
		)
	}

	///////////////////// 2 - PROVISIONING STEP
	/////////// 2A - ADMINS

	getAdminsToProvision() {
		const users = this.state.accessToken.district.users
		const provisionedSchools = _.map(_.values(_.pick(this.state.schools, (school) => school.school_org_id)), (school) => school.clever_id)
		
		console.log("============================>", provisionedSchools)

		var selected = []
		_.each(users, (user) => {
			if (user.role == "district_admin") {
				console.log("district_admin", user)
				selected.push(user)
			} else if (user.role == "staff") {
				// GRAB ADMINS WITH EITHER NO SCHOOL OR PROVISIONED SCHOOL
				var schools = user.data["roles"]["staff"]["schools"]
				if (schools) {
					console.log("???????", user, schools, _.pick(schools, (school) => provisionedSchools.includes(school)))
					if (_.values(_.pick(schools, (school) => provisionedSchools.includes(school))).length > 0) {
						selected.push(user)
					}
				} else {
					selected.push(user)
				}
			}
		})

		return selected
	}

	shouldProvisionAdmins() {
		return this.getAdminsToProvision().length > 0
	}

	renderProvisionAdmins() {
		const admins = this.getAdminsToProvision()

		var rows = _.map(admins, (admin) => {
			if (admin.data["roles"][admin.role].schools) {
				var schools = _.map(
					_.pick(this.state.schools, (school) => admin.data["roles"][admin.role].schools.includes(school.clever_id)), (school) => {
						return school.name	
					}).join(", ")
			}
			return (
				<tr>
					<td>
						{ admin.role }
					</td>
					<td>
						{ admin.data["roles"][admin.role]["title"] }
					</td>
					<td>
						{ admin.first_name }
					</td>
					<td>
						{ admin.last_name }
					</td>
					<td>
						{ admin.email }
					</td>
					<td>
						{ schools }
					</td>
					<td>
						<input className="form-control" type="radio" />
					</td>

				</tr>
			)
		})
		return (
			<div>
				<table className="table">
					<thead>
						<th>
							Role
						</th>
						<th>
							Title
						</th>
						<th>
							First Name
						</th>
						<th>
							Last Name
						</th>
						<th>
							Email
						</th>
						<th>
							School
						</th>
						<th>
							Select
						</th>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
				<LoadingButton loading={ this.state.loading }
					text={ "Provision Admins" }
					className={ "btn btn-primary" }
					onClick={ this.provisionAdmins } />
			</div>
		)
	}

	getSectionsToProvision() {
		const schools = this.state.schools
		var sections = []
		_.each(schools, (school) => {
			console.log("SELECT SECTION", _.pick(school.sections, (section) => section.selected))
			console.log(_.values(_.pick(school.sections, (section) => section.selected)))
			sections = sections.concat(_.values(_.pick(school.sections, (section) => section.selected)))
		})
		return sections
	}
	shouldProvisionSections() {
		return this.getSectionsToProvision().length > 0
	}
	renderProvisionSections() {
		var sections = this.getSectionsToProvision()
		console.log("SECTIONS", sections)
		var rows = _.map(sections, (section) => {
			return (
				<tr>
					<td>
						{ section.name }
					</td>
					<td>
						{ section.subject }
					</td>
					<td>
						{ section.grade }
					</td>
					<td>
						{ section.teachers.length }
					</td>
					<td>
						{ section.students.length  }
					</td>
				</tr>
			)
		})
		return (
			<div>
				<table className="table">
					<thead>
						<tr>
							<th>
								Section Name
							</th>
							<th>
								Subject
							</th>
							<th>
								grade
							</th>
							<th>
								Teachers
							</th>
							<th>
								Students
							</th>
						</tr>
					</thead>
					<tbody>
						{ rows }
					</tbody>
				</table>
				<button className="btn btn-primary">Provision</button>
			</div>
		)
	}

	renderProvision() {
		if (this.shouldProvisionSchools()) {
			var view = this.renderProvisionSchools() 
		} else if (this.shouldProvisionAdmins()) {
			var view = this.renderProvisionAdmins()
		} else if(this.shouldProvisionSections()) {
			var view = this.renderProvisionSections() 
		}
		return (
			<div>
				<h2>
					2 - Provision schools, sections and users
				</h2>
				{ view }
			</div>
		)
	}

	renderMergeAccounts() {
		return (
			<div>
				<h2>
					3 - Merge duplicated accounts
				</h2>
			</div>
		)
	}
	renderOption() {
		var toggleOptions = [
			{ key: "1-link-district", text: "1-Distrit Org" } 
		];

		if (this.state.accessToken && this.state.accessToken.district_org != null) {
			toggleOptions.push({ key: "2-sync-data", text: "2-Sync" })

			if (this.state.schools && this.state.schools.length > 0) {
				toggleOptions.push({ key: "3-link-schools", text: "3-School Orgs" })
				
				if (this.state.schools.length > 0) {
					toggleOptions.push({ key: "4-link-users", text: "4-Merge Users" })
					toggleOptions.push({ key: "5-link-sections", text: "5-Sections" })
					toggleOptions.push({ key: "6-provision-accounts", text: "6-Provision" })
					toggleOptions.push({ key: "7-event-list", text: "7-Events" })
				}
			}
		}

		return (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ (currentStep) => {this.setState({ currentStep })} }
				activeOptionKey={ this.state.currentStep } />
		);
	}
	
	handleMergeStudentsSubmit(suggestionId, cleverUserId) {

		var userIndex = this.state.clever_district.users.findIndex(user => {
		  return user.id === cleverUserId;
		});
		this.state.clever_district.users[userIndex].user_id = suggestionId
		this.setState({clever_district: this.state.clever_district})
	}

	render() {
		var accessToken = this.state.accessToken

		if (accessToken == null) {
			return (
				<div className="CleverAccessTokenDetailsPage container">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else {
			var headerDisplay = (
				<div className="headerSection">
					<header className="pageHeader">
						<h1>Clever token: { this.state.accessToken.district.name }</h1>
					</header>
				</div>
			);

			var linkOptions = this.renderOption()
			var syncedAt = this.renderSyncedAt()

			if (this.state.accessToken && this.state.accessToken.district && this.state.accessToken.district.district_org) {
				var districtOrgName = this.displayDistrictOrgName()
			}

			switch(this.state.currentStep) {
				case "1-link-district":
					var view = <CleverLinkDistrictOrg collapse={false} accessToken={this.state.accessToken} onSelect={this.onSelectDistrictOrg}/>
				break
				case "2-sync-data":
					var view = <CleverSyncDistrictData
								accessToken={this.state.accessToken}
								onAccessTokenSync={this.onAccessTokenSync.bind(this)}/>
				break
				case "3-link-schools":
					var view = <CleverLinkSchoolOrgs 
								 accessToken={this.state.accessToken}
								 onSchoolUptate={this.onSchoolUptate}
								 schools={this.state.schools} /> 
				break
				case "4-link-users":
					var { users, district_org_admin_ids } = this.state.clever_district
					var view = <MergeUsersForm
						duplicateUserIDs={district_org_admin_ids}
						mergeType={'clever'}
						cleverUsers={users}
						afterSubmit={this.handleMergeStudentsSubmit.bind(this)} />
				break
				
				case "5-link-sections":
					var view = <CleverLinkSections 
						schools={this.state.schools} />
				break

				case "6-provision-accounts":
					var view = <CleverProvisioningForm 
						accessToken={this.state.accessToken} />
				break
				case "7-event-list":
					var view = <CleverListEvents 
						accessToken={this.state.accessToken} />
				break
			}
			
		}


		return (
			<div className="CleverAccessTokenDetailsPage container">
				{ headerDisplay }
				{ districtOrgName }
				{ syncedAt }
				{ linkOptions }
				{ view }
			</div>
		);
	}

	componentDidMount() {
		this.fetchAccessToken();
	}

	fetchAccessToken() {
		var accessTokenID = this.props.match.params.id;

		var embed = "clever_access_token.district_org,clever_district.schools,clever_district.admins,clever_school.section_count,clever_district.district_org_admin_ids,clever_district.users"

		CurrentUser.api().getCleverAccessToken(accessTokenID, { embed: embed }, $wr.apiHandler((response) => {
			this.setState({ 
				accessToken: response.clever_access_token,
				clever_district: response.clever_access_token.district,
				schools: response.clever_access_token.district.schools,
				admins: response.clever_access_token.district.admins });
		}));
	}

	// TRIGGERS PULLING ALL INFORMATION FROM CLEVER
	onAccessTokenSync(accessToken) {
		this.setState({accessToken: accessToken})
	}

	onSelectDistrictOrg(districtOrg) {
		this.state.accessToken.district_org = districtOrg
		this.state.accessToken.district.district_org_id = districtOrg.id
		this.setState({accessToken: this.state.accessToken})
	}

	onSchoolUptate(clever_school, school_org) {
		var index = -1 
		_.some(this.state.schools, (school, s) => {
			if (school.clever_id == clever_school.clever_id) {
				index = s
				return true
			}
		})
		var schools = this.state.schools
		schools[index].school_org_id = school_org.id
		this.setState({ schools })
	}

	onDistrictAdminUpdate(clever_admin, admin) {
		var index = -1 
		_.some(this.state.admins, (admin, s) => {
			if (admin.clever_id == clever_admin.clever_id) {
				index = s
				return true
			}
		})
		var admins = this.state.admins
		admins[index].user_id = admin.id
		this.setState({ admins })
	}

	// FETCH SECTIONS ON DEMAND
	loadSections(school) {
		if (!(school.clever_id in this.state.sections)) {
			this.setState({sectionLoading: true})
			var params = {page: 1, per_page: 20, clever_school_id: school.clever_id, embed:"clever_section.teachers,clever_section.student_count"}
			this.loadPaginatedSections(params)
		}
	}
	loadPaginatedSections(params) {
		CurrentUser.api().getCleverSections(params, $wr.apiHandler((response) => {
			var sections = this.state.sections
			if (response.clever_sections.length > 0) {
				const clever_school_id = params["clever_school_id"]
				if (clever_school_id in sections) {
					sections[clever_school_id] = sections[clever_school_id].concat(response.clever_sections)
				} else {
					sections[clever_school_id] = response.clever_sections
				}
				this.setState({ sections: sections });
				params["page"] += 1
				this.loadPaginatedSections(params)
			} else {
				this.setState({sectionLoading: false})
			}
		}));
	}

	toggleAdminelect(admin) {
		console.log("TOGGLING ", admin)
		var newAdmin = { 
			clever_user: {selected: !admin.selected},
		}
		CurrentUser.api().patchCleverUser(admin.id, newAdmin, $wr.apiHandler((response) => {
			var index = 0
			_.some(this.state.admins, (cadmin, i) => {
				if (cadmin.id == admin.id) {
					index = i
					return true
				}
			})	
			var admins = this.state.admins
			admins[i].selected = true
			this.setState({ admins: admins });
		}));
	}

	toggleSectionSelect(section) {
		console.log("TOGGLING ", section)
		var accessTokenID = this.props.match.params.id;
		var newToken = { 
			clever_access_token: { section: {id: section.clever_id, selected: !section.selected}},
			embed: "clever_district.schools,clever_district.users"
		}
		CurrentUser.api().patchCleverAccessToken(accessTokenID, newToken, $wr.apiHandler((response) => {
			this.setState({ accessToken: response.clever_access_token });
		}));
	}

	collectSchoolInfo(school) {
		var info = {
			name: school.name,
			district_name: this.state.accessToken.district.name
		}
		// If location provided by Clever
		if (school.data.location) {
			info["zip"] = school.data.location.zip
			info["state"] = school.data.location.state
		} else {
			// Otherwise grab wizard input
			info["zip"] = this.refs[school.clever_id + "-zip"].value
			info["state"] = this.refs[school.clever_id + "-state"].value
		}
		if (school.clever_id in this.state.selectedCanonicalIDs) {
			info["canonical_id"] = this.state.selectedCanonicalIDs[school.clever_id].id
		}
		return info
	}

	provisionSchools() {
		this.setState({loading: true})
		var schools = this.getSchoolsToProvision()
		
		var loadingIndex = 0
		_.each(schools, (school) => {
			var params = {
				school_org: {
					"school_info": this.collectSchoolInfo(school),
					"district_org_id": this.state.accessToken.district_org.id,
					"clever_school_id": school.clever_id
				}
			}

			loadingIndex += 1
			CurrentUser.api().postSchoolOrgs(params, {}, $wr.apiHandler((response) => {
				console.log(response)
				this.updateSchools(school, response.school_org.id)
				if (loadingIndex == schools.length) {
					this.setState({loading: false})
				}
			}))
		})
	}

	updateSchools(updateSchool, schoolOrgId) {
		var selectedIndex = 0

		_.some(this.state.schools, (school, s) => {
			if (updateSchool.clever_id == school.clever_id) {
				selectedIndex = s
				return true
			}
		})

		this.state.schools[selectedIndex].school_org_id = schoolOrgId
		console.log("=-==========", schoolOrgId, updateSchool, selectedIndex, this.state.schools[selectedIndex])
		this.setState({schools: this.state.schools})

	}
};

CleverAccessTokenDetailsPage.propTypes = PageStrictPropTypes({
});


module.exports = CleverAccessTokenDetailsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverAccessTokenDetailsPage.js